import React, { useState, useEffect } from "react";
import { fetchCustomers } from "../api/customerService"; // Ensure this API is implemented

function CustomerSearchDropdown({ value, onChange }) {
  const [query, setQuery] = useState(value || "");
  const [customers, setCustomers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (query.length < 2) {
      setCustomers([]);
      return;
    }

    const fetchMatchingCustomers = async () => {
      setLoading(true);
      try {
        const response = await fetchCustomers({ search: query });
        console.log('Fetch Customers',response);
        setCustomers(response);
      } catch (err) {
        setError("Failed to fetch customers.");
      } finally {
        setLoading(false);
      }
    };

    const debounceTimeout = setTimeout(fetchMatchingCustomers, 300); // Debounce API calls
    return () => clearTimeout(debounceTimeout);
  }, [query]);

  useEffect(() => {
    setQuery(value || ""); // ✅ Sync query with the value prop when it changes
  }, [value]);

  const handleSelectCustomer = (customer) => {
    const customerName = customer.company_name || customer.name;
    setQuery(customerName);
    setSelectedCustomer(customer);
    setShowDropdown(false);
    onChange({ customer_id: customer.customer_id, customer_name: customerName });
  };

  return (
    <div className="relative w-full">
      <input
        type="text"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setShowDropdown(true);
        }}
        placeholder="Search customer by name"
        className="border p-2 rounded w-full"
      />
      {loading && <p className="text-sm text-gray-500">Loading...</p>}
      {error && <p className="text-sm text-red-500">{error}</p>}

      {showDropdown && customers.length > 0 && (
        <ul className="absolute z-10 bg-white border rounded-md shadow-lg mt-1 w-full max-h-40 overflow-y-auto">
{customers.map((customer) => (
  <li
    key={customer.customer_id}
    onClick={() => handleSelectCustomer(customer)}
    className="px-4 py-2 cursor-pointer hover:bg-gray-100"
  >
    {customer.company_name || customer.name} ({customer.email}) {/* ✅ Use correct fields */}
  </li>
))}
        </ul>
      )}

      {selectedCustomer && (
        <p className="text-sm text-gray-600 mt-1">
          Selected: {selectedCustomer.customer_name}
        </p>
      )}
    </div>
  );
}

export default CustomerSearchDropdown;